const paramsToRemove = ['refSource', 'searchEvent', 'utm_term'];

export default paramsToRemove;
